import React from 'react';
import { Visibility, type VisibilityConfigFieldsFragment } from '~/api/graphql';
import { useOptionalCurrentAgencyUser } from '~/components/current-user';
import {
  visibilityValueFromFragment,
  type VisibilitySelectorValue
} from './visibility-selector.utils';

export const createPublicVisibilityValue = (): VisibilitySelectorValue => ({
  level: Visibility.Public,
  userIds: [],
  teamIds: []
});

export const defaultVisibilityValueFromFragment = (
  visibility: VisibilityConfigFieldsFragment | null | undefined,
  options?: { disallowPrivate?: boolean }
): VisibilitySelectorValue => {
  if (options?.disallowPrivate && visibility?.level === Visibility.Private) {
    return createPublicVisibilityValue();
  }
  return visibilityValueFromFragment(visibility);
};

export const useDefaultVisibilityValue = (): VisibilitySelectorValue => {
  const agencyUser = useOptionalCurrentAgencyUser();
  const defaultVisibility = agencyUser?.preferences.defaultVisibility;
  const disallowPrivate = agencyUser?.agency.configuration.visibility.disallowPrivate ?? false;

  return React.useMemo(
    () => defaultVisibilityValueFromFragment(defaultVisibility, { disallowPrivate }),
    [
      defaultVisibility?.level,
      defaultVisibility?.userIds,
      defaultVisibility?.teamIds,
      disallowPrivate
    ]
  );
};
